import type { AssetWorkflowOptions } from '../../types';

export const addScheduleWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addScheduleWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'schedule',
  workflowIndex: 1,
  workflowName: 'Create Schedule Workflow',
  workflowDescription: 'Create Schedule Workflow that your fulfillment origin work with',
  workflowAssets: ['fulfillmentContext', 'schedule'],
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Schedule ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this schedule',
        description: 'This is optional but will allow you to more easily reference this schedule in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'scheduleName',
      workflowStepNavigationName: 'Schedule Name',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'What will you call this schedule',
        description: 'Add a name for the schedule to refer back to it',
        help: 'Add an name for the schedule you are creating. The schedule will be utilized by an FC so it might make sense to name the schedule based on the FC you will later associate it with.',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'scheduleDescription',
      workflowStepNavigationName: 'Schedule Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 2,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'scheduleEntry',
      workflowStepNavigationName: 'Add a schedule',
      workflowComponent: {
        workflowComponentType: 'scheduleEntry',
        prompt: 'Add an entry for your schedule',
        description: 'When can the FC guarantee shipments ordered today will go out?',
        help: 'Create a schedule entry for your fulfillment network. Essentially an operations calendar for an FC. You will be able to add additional future entries later.',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'entries',
      },
    },
    {
      workflowStepKey: 'tenantSelect',
      workflowStepNavigationName: 'Tenant Select',
      optional: true,
      workflowComponent: {
        assetType: 'tenant',
        workflowComponentType: 'tenantSelect',
        prompt: 'Does this schedule belong to a specific tenant?',
        description: '',
        help: 'Specifying a tenant will allow you to more easily filter you various configuration pieces',
      },
      workflowStepConditionalMatcher: [
        {
          assetType: 'tenant',
          schema: { type: 'array', minItems: 1 },
        },
      ],
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetType: 'tenant',
        linkType: 'Tenant',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add schedule Summary',
        description: 'The schedule will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
